module.exports = __webpack_public_path__ + "static/media/arrow-down.c827df8d.svg";